module.exports = __webpack_public_path__ + "img/index_ps_01.9a7eee3c.jpg";